import {
  bl_cms_form_template_ext_RowClass,
  bl_pgw_payment_provider_hdr_RowClass,
  bl_pgw_payment_provider_hdr_RowInterface,
} from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class PaymentProviderContainerModel extends BaseContainerModel {
  bl_pgw_payment_provider_hdr: bl_pgw_payment_provider_hdr_RowInterface =
    new bl_pgw_payment_provider_hdr_RowClass();
  bl_pgw_payment_provider_exts: bl_cms_form_template_ext_RowClass[] = [];
}
